import { render } from "./JsonInput2.vue?vue&type=template&id=5462ec39"
import script from "./JsonInput2.vue?vue&type=script&lang=js"
export * from "./JsonInput2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__